// Libraries
import React from "react";
import { connect } from 'react-redux';

// Local Libraries
import { gisRoutes } from "../../../routes/routes";
import phrasebookLoad from "../../../i18n";
import { capitalizeFirstLetter } from "../../../helpers/util"
import * as token from '../../../helpers/token';
import { accountTypesConstants } from '../../../constants';
import { initialState, updateState, serviceNumberTypeInfo } from '../../Management/ServiceNumberType/serviceNumberTypeForm';


// Redux
import { vendorActions, serviceNumberTypeActions, georesourceActions } from 'actions';


// Components
import { NewBreadcrumbs } from "../../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";

import { DisplayInfo } from "../../../components/SkyFramework/Boxes/DisplayInfo"
import { LinkButton } from "../../../components/SkyFramework/Buttons";
import { Form } from "../../../components/SkyFramework/Forms";

// Constants
const phrasebook = phrasebookLoad()

class ServiceNumberCoverageType extends React.Component {
  constructor(props) {
    super(props);

    this.state = initialState(phrasebook, this.props.match.params.id)
    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];

  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.props.dispatch(serviceNumberTypeActions.get(this.props.match.params.id));
    }
    //
  }

  componentDidUpdate(prevProps) {
    if (this.props.servicenumbertype && prevProps && prevProps.servicenumbertype !== this.props.servicenumbertype) {
      this.setState(updateState(this.props.servicenumbertype));
    }
  }

  infoServiceNumberType(servicenumber) {
    var inputs = serviceNumberTypeInfo(phrasebook, servicenumber);
    return <DisplayInfo inputs={inputs} />
  }

  render() {
    if (this.state.service_number_type) {
      return (<>
        {/* <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home },
        { link: gisRoutes.management.service_number_coverage.list, label: phrasebook.numbers.service_number_types }]} current={phrasebook.headerlinks.service_coverage} /> */}
        <div className="box p-1 p-sm-2">
          <h2 className="box-title pb-1 mb-1">{phrasebook.orders.detail_services}</h2>
          {serviceNumberTypeInfo(phrasebook, this.state.service_number_type, false)}
          {/* {this.infoServiceNumberType(this.state.service_number_type)} */}
          <div className="box-actions-footer">
            <LinkButton title={phrasebook.common.back} link={gisRoutes.visitor.service_number_coverage} />
          </div>
        </div>
      </>)
    } else return null;
  }
}

function mapStateToProps(state) {
  const { servicenumbertype } = state;
  return {
    servicenumbertype: servicenumbertype.servicenumbertype
  };
}


const serviceNumberCoverageType = connect(mapStateToProps)(ServiceNumberCoverageType);
export default (serviceNumberCoverageType);
